var map = {
	"./default/privacy-policy.html": 786,
	"./nl-BE/privacy-policy.html": 790
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;



//////////////////
// WEBPACK FOOTER
// ./app/views/legal/partials privacy-policy\.html$
// module id = 465
// module chunks = 9